document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(event) {
      const target = event.target;
      if (target.matches('[name="checkout"], [name="goto_pp"], [name="goto_gc"]')) {
        const agreeCheckbox = document.getElementById('agree');
        if (agreeCheckbox.checked) {
          event.target.form.submit();
        } else {
          alert(Shopify.translations.cartAcceptTerms);
          event.preventDefault();
        }
      }
    });
  });